module.exports = __webpack_public_path__ + "img/HERO-head-03-meora.f8f82080.png";